import { render, staticRenderFns } from "./load-afilliate-file.vue?vue&type=template&id=1ad75e63&scoped=true"
import script from "./load-afilliate-file.vue?vue&type=script&lang=js"
export * from "./load-afilliate-file.vue?vue&type=script&lang=js"
import style0 from "./load-afilliate-file.vue?vue&type=style&index=0&id=1ad75e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad75e63",
  null
  
)

export default component.exports